import { useQuery } from "@tanstack/react-query";
import { groupBy } from "lodash";
import { useMemo } from "react";
import useClientAccounts from "../../Dashboard/hooks/useClientAccounts";
import getACH, { url } from "../requests/getACH";
export const keyMaker = (config) => config ? [config.clientId, url()] : undefined;
export default function useGetACH(authConfig) {
    const accounts = useClientAccounts(authConfig?.clientId ?? null, authConfig ?? { clientId: "null", jwt: "null" }, false);
    const { data: queryData, status: queryStatus, error: queryError, } = useQuery({
        // eslint-disable-next-line @tanstack/query/exhaustive-deps
        queryKey: keyMaker(authConfig),
        queryFn: async () => (authConfig === null ? undefined : getACH(authConfig)),
        enabled: authConfig !== null,
    });
    const result = useMemo(() => {
        if (accounts.isLoading || accounts.hasError) {
            return accounts;
        }
        if (queryStatus === "error") {
            return {
                data: undefined,
                isLoading: false,
                hasError: true,
                error: queryError,
            };
        }
        if (queryStatus === "loading") {
            return { data: undefined, isLoading: true, hasError: false };
        }
        if (queryData === undefined) {
            return {
                data: undefined,
                isLoading: false,
                hasError: true,
                error: new Error("Unknown error"),
            };
        }
        const externalAccountsDB = groupBy(accounts.data.externalAccounts, (a) => a.accountId);
        const fartherAccountsDB = groupBy(accounts.data.fartherAccounts, (a) => a.accountId);
        const zippedTransfers = queryData.map(({ fundingAccountId, iraContributionDetails, custodianDetails: _c, ...t }) => ({
            ...t,
            externalAccountId: fundingAccountId,
            externalAccount: externalAccountsDB[fundingAccountId]?.[0] ?? null,
            fartherAccount: fartherAccountsDB[t.physicalAccountId]?.[0] ?? null,
            iraContributionYear: iraContributionDetails
                ? Math.floor(iraContributionDetails.contributionYear)
                : null,
        }));
        return { data: zippedTransfers, isLoading: false, hasError: false };
    }, [accounts, queryData, queryStatus, queryError]);
    return result;
}
//# sourceMappingURL=useGetACH.js.map